export const NEWLY_ADDED_CLIENT_ID = 'a6d7c65e-34f9-41e7-81cb-55be6b3b5e8b'
